import type { ServerSetting } from '../../../services/adminServerSettings';
import type { UnitCosts } from '../../../services/adminUnits';
import ActualCosts from './ActualCosts';
import CostEstimate from './CostEstimate';
import { estimatePolicy } from './unitCosts';

interface UnitsCostsProps {
  costs: UnitCosts;
  /** Null until loaded; the estimate's policy comes from them. */
  settings: ServerSetting[] | null;
  /** The policy's values as they stand in their controls, saved or not. */
  drafts: Record<string, string>;
}

function PartError({ text }: { text: string }) {
  return <div className="field"><div className="err">{text}</div></div>;
}

function azureErrors(costs: UnitCosts): string[] {
  const { lastMonth, monthToDate } = costs;
  if (lastMonth.error && lastMonth.error === monthToDate.error) return [`Could not load the Azure costs: ${lastMonth.error}`];
  return [
    lastMonth.error && `Could not load last month: ${lastMonth.error}`,
    monthToDate.error && `Could not load this month: ${monthToDate.error}`,
  ].filter((text): text is string => !!text);
}

/** Azure's costs by service, and next month's estimate at the policy as it is being edited. */
export default function UnitsCosts({ costs, settings, drafts }: UnitsCostsProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {azureErrors(costs).map((text) => (
        <PartError key={text} text={text} />
      ))}
      <ActualCosts lastMonth={costs.lastMonth} monthToDate={costs.monthToDate} />
      {costs.unitHours.error && <PartError text={`Could not load the units' hours: ${costs.unitHours.error}`} />}
      {costs.unitHours.value && settings && (
        <CostEstimate hours={costs.unitHours.value} prices={costs.prices} policy={estimatePolicy(settings, drafts)} />
      )}
    </div>
  );
}
